import { LAYOUTS, OpenNewTabTargetType, POSITION, } from '@voltmoney/types';
import { FontFamilyTokens, FontSizeTokens, LottieSizeTokens, LottieTokens, StackJustifyContent, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { AppLink } from "../../configs/constants";
export const template = {
    layout: {
        id: ROUTE.PARTNER_LED_JOURNEY,
        type: LAYOUTS.LIST,
        widgets: [
            {
                id: 'lottie',
                type: WIDGET.LOTTIE,
                position: POSITION.ABSOLUTE_CENTER,
            },
            {
                id: 'lottieTextStack',
                type: WIDGET.STACK,
                position: POSITION.ABSOLUTE_CENTER,
            },
        ],
    },
    datastore: {
        lottie: {
            uri: LottieTokens.LoadingSplash,
            size: LottieSizeTokens.XXXL,
            autoplay: true,
        },
        lottieTextStack: {
            type: StackType.row,
            justifyContent: StackJustifyContent.center,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'lottieTextStackT1', type: WIDGET.TEXT }
            ]
        },
        lottieTextStackT1: {
            label: 'Redirecting to app in few seconds',
            fontWeight: '600',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.MD,
        }
    },
};
let copyExtraProps = {};
export const marketLeadsRedirect = {
    onLoad: async (_, extraProps) => {
        copyExtraProps = extraProps;
        setTimeout(() => {
            _.openNewTab(`${AppLink}`, OpenNewTabTargetType.parent);
        }, 3000);
        return Promise.resolve(template);
    },
    // actions: { [ACTION.REDIRECT_ACTION]: RedirectAction },
    // action: {
    //     routeId: ROUTE.PARTNER_LED_JOURNEY,
    //     type: ACTION.REDIRECT_ACTION,
    //     payload: { ...copyExtraProps },
    // },
    // actionDelay: 0,
};
